/**
 * Get initials from a name string
 * @param {string} name - Full name
 * @returns {string} - Initials (up to 2 characters)
 */
export const getInitials = (name) => {
    if (!name) return '?';

    const names = name.trim().split(' ');
    if (names.length === 1) {
        return names[0].charAt(0).toUpperCase();
    }

    return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
};
